import GroupSignature from './GroupSignature'

export default GroupSignature
